export const ModuleType = Object.freeze({
  IMAGE: 'modules-image',
  TITLE: 'modules-title',
  TEXT: 'modules-text',
  VIDEO: 'modules-video',
  DIVIDER: 'modules-divider',
  BUTTON_GROUP: 'modules-button-group'
});

export const VideoMode = Object.freeze({
  SHOOTSTA_PLAYER: 'shootsta-player',
  PLAYER_CONTROLS: 'player-controls',
  PLAYER_NO_CONTROLS: 'player-no-controls'
});

export const ActionTypes = Object.freeze({
  INSERT: 'INSERT',
  UPDATE_BLOCK: 'UPDATE_BLOCK',
  UPDATE_ROW: 'UPDATE_ROW',
  UPDATE_ROW_VIDEO: 'UPDATE_ROW_VIDEO',
  DELETE_ROW_VIDEO: 'DELETE_ROW_VIDEO'
});

export const ImageSizes = Object.freeze({
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
});

export const ImageSizeTypes = Object.freeze({
  RECTANGLE: 'rectangle',
  SQUARE: 'square'
});